import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';

export default function LeaderboardScreen() {
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.background }]}>
      <View style={styles.content}>
        <View style={[styles.iconWrapper, { backgroundColor: '#F59E0B20' }]}>
          <Ionicons name="trophy" size={48} color="#F59E0B" />
        </View>
        <Text style={[styles.title, { color: colors.textPrimary }]}>Leaderboard</Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
          Rankings and competitions coming soon
        </Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  iconWrapper: {
    width: 96,
    height: 96,
    borderRadius: 48,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    textAlign: 'center',
  },
});
